export const GET_UNIT_REQUEST = 'GET_UNIT_REQUEST';
export const GET_UNIT_DATA = 'GET_UNIT_DATA';
export const GET_UNIT_ERROR = 'GET_UNIT_ERROR';

export const CREATE_UNIT_REQUEST = 'CREATE_UNIT_REQUEST';
export const CREATE_UNIT_DATA = 'CREATE_UNIT_DATA';
export const CREATE_UNIT_ERROR = 'CREATE_UNIT_ERROR';

export const UPDATE_UNIT_REQUEST = 'UPDATE_UNIT_REQUEST';
export const UPDATE_UNIT_DATA = 'UPDATE_UNIT_DATA';
export const UPDATE_UNIT_ERROR = 'UPDATE_UNIT_ERROR';

export const DELETE_UNIT_REQUEST = 'DELETE_UNIT_REQUEST';
export const DELETE_UNIT_DATA = 'DELETE_UNIT_DATA';
export const DELETE_UNIT_ERROR = 'DELETE_UNIT_ERROR';
